import React, { useState } from "react";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextHeader,
  TextareaField,
} from "../../../../components";
import styles from "./RsvpTidbits.module.css";
import { AiFillPlusCircle, AiOutlineCheck } from "react-icons/ai";
import { Col, List, Row } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
import { IoMdAdd } from "react-icons/io";
import { FaRegCheckSquare } from "react-icons/fa";

const RsvpTidbits = () => {
  const getTidbit = useSelector((state) => state.EventPlanningReducer.Tidbits);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const { state } = useLocation();
  const eventData =  state?.eventData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [options, setOptions] = useState("");

  console.log(RSVP);

  const next = () => {
    if (getTidbit?.length == 0 || !getTidbit[getTidbit?.length - 1].question) {
      dispatch(
        showAlert({
          type: "Error",
          title: "Tidbits",
          message: "Please add few Questions!",
          status: 400,
        })
      );
    } else {
      let data = {
        ...RSVP,
        tidbits: getTidbit,
      };
      dispatch(setRSVP(data));
      navigate("/events/rsvp/rsvpschedule", {
        state: { headrTitle: "RSVP" , eventData: eventData},
      })
      // navigation.navigate("Schedule")
    }
  };
  return (
    <div>
      <Row className={styles.textContainer}>
        <TextHeader text={"4. Tidbits"} />
        <Row className={styles.innerContainer}>
          <AiFillPlusCircle
            className={styles.icon}
            size={40}
            onClick={() =>
              navigate("/events/rsvp/addquestions", {
                state: { headrTitle: "Add Tidbits" },
              })
            }
          />
          <TextComponent text={"Add Question"} textClass={styles.innertext} />
        </Row>
      </Row>
      {getTidbit?.length > 0 && (
        <List
          grid={{
            gutter: 16,
            xs: 2,
            sm: 2,
            md: 2,
            lg: 2,
            xl: 2,
            xxl: 2,
          }}
          className={styles.list}
          dataSource={getTidbit}
          renderItem={(item, index) => {
            return (
              item?.question && (
                <div className={styles.listItem}>
                  <TextComponent
                    textClass={styles.listQuestion}
                    text={`${index + 1}. ${item.question}`}
                  />
                  <div className={styles.options}>
                    {item?.answerType == "Options" ? (
                      <div>
                        {item?.options.map((item, index) => {
                          console.log("optionss", item);
                          return (
                            <div key={index} className={styles.optionContainer}>
                              <TextComponent
                                style={{ width: "100%" }}
                                text={item?.option}
                              />
                            </div>
                          );
                        })}
                      </div>
                    ) : item?.answerType == "Multiple Choice" ? (
                      <div>
                        {item?.options.map((item, index) => {
                          console.log("optionss", item);
                          return (
                            <div key={index} className={styles.optionContainer}>
                              <FaRegCheckSquare className={styles.icon} />

                              <TextComponent
                                style={{ width: "100%" }}
                                text={item?.option}
                              />
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <TextareaField disabled={true} />
                    )}
                  </div>
                </div>
              )
            );
          }}
        />
      )}
      {/* {getTidbit?.length > 0 && getTidbit?.map((item, index)=>{
        return item?.question && (
          <Row gutter={[16, 16]} className={styles.inputContainer}>
            hellllllllllloooo

          </Row>
        )
      })} */}
      
      
      <Row gutter={[16, 16]} className={styles.btnRow}>
        <Col xs={24} sm={12} md={10} lg={8} xl={7}>
          <SubmitButton
            btnClass={styles.btnClass}
            title="Next"
            onClick={next}
          />
        </Col>
      </Row>
    </div>
  );
};

export default RsvpTidbits;
